<template>
<div class="page-container">
  <el-breadcrumb separator="/" class="page-breadcrumb">
    <el-breadcrumb-item>
      监控日志
    </el-breadcrumb-item>
  </el-breadcrumb>
  <el-card shadow="never" class="page-content">
    <div class="page-actions">
      <el-input
        placeholder="请输入内容"
        @input="onSearch"
        clearable
      >
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
    </div>
    <log-list></log-list>
  </el-card>
</div>
</template>

<script>
import './store';
import LogList from './components/list';
import { mapActions } from 'vuex';

export default {
  name: 'Logs',
  components: {
    LogList
  },
  methods: {
    ...mapActions('logs', ['list'])
  },
  created() {
    this.list();
  }
};
</script>

<style lang="less" scoped>
</style>
